import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, signal, Signal } from '@angular/core';

import { ApiHttpResponse, IconType, Workout } from '@kinomap-dev/ng-ui-lib/core';
import { EmptyContentListElement } from '../../../components/empty-content-list-element/empty-content-list-element';
import { Paginator } from '../../../components/paginator/paginator';
import { Table } from '../../../components/table/table';
import { ProfileService } from '../../../services/profile.service';
import { TableContentService, CONTENT_TYPE_TOKEN } from '../../../services/table-content.service';
import { convertWorkoutToWorkoutContentTableItem } from '../../../utils/workout-to-workout-content-table-data.helpers';
import { FilterService } from '../../../services/filters.service';
import { TableColumnsService } from '../../../services/table-columns.service';

const tableHeaderElements: string[] = [
  'sport',
  'mode',
  'duration',
  'level',
  'sessions',
  'comments',
  'likes',
  // 'labels', // Hidden while the tags topic is on standby
];

@Component({
  selector: 'app-workout-list',
  imports: [NgTemplateOutlet, EmptyContentListElement, Table, Paginator],
  templateUrl: './workout-list.html',
  styleUrl: '../content-list.scss',
  providers: [
    FilterService,
    TableContentService,
    TableColumnsService,
    { provide: CONTENT_TYPE_TOKEN, useValue: 'workout' },
  ],
})
export class WorkoutList {
  public workoutTableContentService: TableContentService = inject(TableContentService);
  readonly tableColumnsService: TableColumnsService = inject(TableColumnsService);
  profileService: ProfileService = inject(ProfileService);
  readonly emptyList: Signal<boolean> = computed(() => this.profileWorkoutCount() === 0);
  readonly actions: Signal<IconType[]> = signal<IconType[]>(['edit', 'options']);
  readonly workoutTableData: Signal<ApiHttpResponse<Workout[]> | undefined> = this
    .workoutTableContentService.tableData as Signal<ApiHttpResponse<Workout[]>>;

  private profileWorkoutCount = computed(() => this.profileService.profile()?.workout_count ?? 0);
  readonly skeletonCount: Signal<number> = computed(() => {
    if (this.profileWorkoutCount() < this.workoutTableContentService.contentLimitPerPage()) {
      return this.profileWorkoutCount();
    }
    return this.workoutTableContentService.contentLimitPerPage();
  });

  readonly tableData: Signal<any[] | undefined> = computed(() => {
    const data: Workout[] | undefined = this.workoutTableData()?.data;
    if (!data || !Array.isArray(data)) return undefined;
    return data.map((row: Workout) => {
      return convertWorkoutToWorkoutContentTableItem(row);
    });
  });

  constructor() {
    this.tableColumnsService.setColumns(tableHeaderElements);
  }
}
